import { RepositoryFactory, Repositories } from '@/repositories/repositoryFactory'
import StaticFileRepository from '@/repositories/staticFileRepository'
import VueI18n from 'vue-i18n'

export default class TranslationModel {
  langs : Array<string> = ['en', 'nl', 'fr']
  translations: any = { 'en': {}, 'nl': {}, 'fr': {} }

}
